import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ManageUserService } from '../manage-user.service';
import { User } from '../../../core/user';
import { FormBuilder, FormGroup } from '@angular/forms';
import { tap, finalize } from 'rxjs/operators';
import {
  AngularFireStorage,
  AngularFireUploadTask,
} from 'angularfire2/storage';
import { Observable } from '../../../../../node_modules/rxjs/Observable';
import { AuthService } from '../../../core/auth.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css'],
})
export class EditUserComponent implements OnInit {
  uid: string;
  userData: User;
  rEditUserForm: FormGroup;
  rAddNewUserForm: FormGroup;

  displayName: string;
  email: string;
  admin: boolean;
  editor: boolean;
  superAdmin: boolean;
  updateUserData: User;
  flag: boolean;
  newUserData: User;
  userPassword: string;
  newUserAdmin: boolean;
  newUserEditor: boolean;
  newUserSuperAdmin: boolean;
  isAdmin=false;

  // File Upload
  uploadTask: AngularFireUploadTask;
  percentage: Observable<number>;
  snapshot: Observable<any>;
  downloadURL: Observable<string>;
  isHovering: boolean;
  processError: string;
  photoURL: string;
  constructor(
    private _Activatedroute: ActivatedRoute,
    private manageUserService: ManageUserService,
    private fb: FormBuilder,
    private storage: AngularFireStorage,
    private auth: AuthService
  ) {
    this.rEditUserForm = fb.group({
      displayName: '',
      email: '',
      admin: false,
      editor: false,
      superAdmin: false,
    });

    this.rAddNewUserForm = fb.group({
      displayName: '',
      email: '',
      userPassword: '',
      admin: false,
      editor: false,
      superAdmin: false,
    });

    // this.flag = false;
    // this.uid = null;

    // this.uid = this._Activatedroute.snapshot.params['uid'];
    // console.log("flagvalue" + this.flag);
    // console.log(this.uid);

    // if ( this.uid !== null)
    // {
    //   this.flag = true;
    // }

    this.newUserAdmin = false;
    this.newUserEditor = false;
    this.newUserSuperAdmin = false;
    this.errorCallback = this.errorCallback.bind(this);
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  startUpload(event: FileList) {
    const file = event.item(0);
    if (file.type.split('/')[0] !== 'image') {
      console.log('unsupported file type');
      alert('unsupported file type');
      return;
    }
    const path = `DP/${new Date().getTime()}_${file.name}`;
    const ref = this.storage.ref(path);
    const customMetadata = { app: 'My Advisor Admin Panel', cacheControl: "public, max-age=31536000"};
    this.uploadTask = this.storage.upload(path, file, {customMetadata});
    this.percentage  = this.uploadTask.percentageChanges().pipe(
      tap(snap=>{
        console.log(snap);
        if(snap == 100){
          console.log('here');
          // "https://myadwisor.appspot.com.storage.googleapis.com/DP/1534250681732_38dcdb7d9a697017-2048x1024.jpg";
          ref.getDownloadURL().pipe(
            tap(url=>{
              console.log(url);
              if(url!=null){
                this.photoURL = url;
                if(!this.photoURL.endsWith('alt=media')){
                  this.photoURL += 'alt=media';
                }
              }
            }));
        }
      })
    );
    // this.uploadTask.downloadURL().do(url=>{
    //   console.log(url);
    //   this.photoURL = url;
    // })
    // this.uploadTask.snapshotChanges().pipe(
    //   finalize(()=>this.downloadURL = this.storage.ref(path).getDownloadURL().pipe(
    //     tap(url=>{
    //       console.log(url);
    //       if(url!=null){
    //         this.photoURL = url;
    //         // if(!this.photoURL.endsWith('alt=media')){
    //         //   this.photoURL += 'alt=media';
    //         // }
    //       }
    //     })
    //   ))
    // ).subscribe(snap=>{
    //   console.log(snap);
    // });
    
    // this.downloadURL = this.uploadTask.downloadURL().pipe(
    //   tap(url=>{
    //     console.log(url);
    //     if(url!=null){
    //       this.photoURL = url;
    //     }
    //   })
    // )
  }

  isActive(snapshot){
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
  }

  ngOnInit() {
    this.flag = false;
    this.uid = null;
    this.uid = this._Activatedroute.snapshot.params['uid'];
    console.log('uid' + this.uid);
    console.log('flagvalue' + this.flag);
    if (typeof this.uid !== 'undefined') {
      this.flag = true;
    }
    console.log(this.flag);
    this.auth.getCurrentUser().subscribe(user=>{
      console.log("here");
      console.log(user);
        if(user.roles.superAdmin == true){
          this.isAdmin = true;
        }
    });

    this.manageUserService.getDataByKey(this.uid).subscribe((value) => {
      this.userData = value;
      console.log(this.userData);
      this.photoURL = value.photoURL;
    });
  }

  updateUser(formValue) {
    this.updateUserData = {
      uid: this.userData.uid,
      displayName: formValue.displayName,
      email: formValue.email,
      photoURL: this.photoURL || '',
      roles: {
        admin: formValue.admin,
        editor: formValue.editor,
        superAdmin: formValue.superAdmin,
      },
    };
    console.log(JSON.stringify(this.updateUserData));

    this.manageUserService.update(this.updateUserData);
  }

  addUser(newUserFormValue) {
    // console.log(newUserFormValue.displayName);
    // console.log(newUserFormValue.userPassword);
    // console.log(newUserFormValue.email);
    // console.log(newUserFormValue.admin);
    // console.log(newUserFormValue.editor);
    this.manageUserService.createUser(newUserFormValue, this.errorCallback);
  }
  errorCallback(error){
    console.log(error);
    this.processError = error.message;
  }
  logout($event) {
    $event.preventDefault();
    this.auth.signOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/manage-user/edit-user/edit-user.component.ts